import React, { useState } from "react";
import signinimage from "../../images/signin-g.svg";
import { Link, useNavigate } from "react-router-dom";
import ScrollToTop from "../ScrollToTop";
import api from "../../utils/api";

const MyAccountSignIn = () => {
  const navigate = useNavigate();

  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSignIn = async (e) => {
    e.preventDefault();
    setError("");

    if (!/^[0-9]{10}$/.test(mobile)) {
      setError("Enter valid 10-digit mobile number");
      return;
    }

    if (!password) {
      setError("Password is required");
      return;
    }

    try {
      setLoading(true);

      const res = await api.post("/api/auth/login", {
        phone: mobile,
        password,
      });

      /* ✅ CORRECT STORAGE */
      localStorage.setItem("token", res.data.token);
      localStorage.setItem(
        "user",
        JSON.stringify(res.data.user)
      );
      localStorage.setItem(
        "userId",
        res.data.user._id
      );

      navigate("/", { replace: true });
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Invalid mobile or password"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <ScrollToTop />

      <section className="my-lg-14 my-8">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            {/* IMAGE */}
            <div className="col-12 col-md-6 col-lg-4 order-lg-1 order-2">
              <img
                src={signinimage}
                alt="signin"
                className="img-fluid"
              />
            </div>

            {/* FORM */}
            <div className="col-12 col-md-6 offset-lg-1 col-lg-4 order-lg-2 order-1">
              <h1 className="mb-3 h2 fw-bold">Sign in</h1>

              {error && (
                <div className="alert alert-danger">
                  {error}
                </div>
              )}

              <form onSubmit={handleSignIn}>
                <input
                  type="tel"
                  className="form-control mb-3"
                  placeholder="Mobile number"
                  value={mobile}
                  maxLength={10}
                  onChange={(e) =>
                    setMobile(
                      e.target.value.replace(/\D/g, "")
                    )
                  }
                  required
                />

                <input
                  type="password"
                  className="form-control mb-2"
                  placeholder="Password"
                  value={password}
                  onChange={(e) =>
                    setPassword(e.target.value)
                  }
                  required
                />

                <div className="d-flex justify-content-between mb-3">
                  <Link to="/MyAccountForgetPassword">
                    Forgot password?
                  </Link>
                </div>

                <button
                  type="submit"
                  className="btn btn-primary w-100"
                  disabled={loading}
                >
                  {loading ? "Signing in..." : "Sign In"}
                </button>

                <div className="text-center mt-3">
                  Don’t have an account?{" "}
                  <Link to="/MyAccountSignUp">
                    Register
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MyAccountSignIn;